/* eslint-disable @typescript-eslint/no-explicit-any */
declare global {
  interface Window {
    gtag: any
  }
}

export const GA_TRACKING_ID = process.env.NEXT_PUBLIC_GA_TRACKING_ID

export type PageViewOptions = {
  title?: string
  location?: string
  path?: string
}

export const pageView = ({ title, location, path }: PageViewOptions = {}): void => {
  if (!GA_TRACKING_ID || !window?.gtag) {
    return
  }

  window.gtag('event', 'page_view', {
    page_location: location ?? window.location.href,
    ...(title !== undefined ? { page_title: title } : {}),
    ...(path !== undefined ? { page_path: path } : {}),
  })
}

export type EventOptions = Record<string, any> & {
  category?: string
  label?: string
  value?: number
  nonInteraction?: boolean
  userId?: string
}

export const event = (action: string, { category, label, value, nonInteraction, userId, ...otherOptions }: EventOptions = {}): void => {
  if (!window?.gtag) {
    return
  }

  const eventOptions: Record<string, any> & {
    event_category?: string
    event_label?: string
    value?: number
    non_interaction?: boolean
    user_id?: string
  } = { ...otherOptions }

  if (category !== undefined) {
    eventOptions.event_category = category
  }

  if (label !== undefined) {
    eventOptions.event_label = label
  }

  if (value !== undefined) {
    eventOptions.value = value
  }

  if (nonInteraction !== undefined) {
    eventOptions.non_interaction = nonInteraction
  }

  if (userId !== undefined) {
    eventOptions.user_id = userId
  }

  window.gtag('event', action, eventOptions)
}
